import { render, staticRenderFns } from "./optionsTable.vue?vue&type=template&id=399cf1a5&"
import script from "./optionsTable.vue?vue&type=script&lang=js&"
export * from "./optionsTable.vue?vue&type=script&lang=js&"
import style0 from "./optionsTable.vue?vue&type=style&index=0&id=399cf1a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports